<template>
  <div class="">
    <headerbox></headerbox>

    <div class="main">
      <hotelhead></hotelhead>
      <div class="reviews">
        <div class="reviewsleft">
          <menuTitle :titles="lefttitles"></menuTitle>
          <div class="comments">
            <ul>
              <li v-for="comment in commentslist" :key="comment.id">
                <div class="commentsphoto">
                  <img :src="comment.avatar" alt="" />
                </div>
                <div class="commentstext">
                  <h3>{{ comment.phoneNumber }}</h3>
                  <h4>{{ comment.comment }}</h4>
                  <p>
                    <img
                      :src="require('@/assets/images/like.png').default"
                      alt=""
                    />
                    点赞数: {{ comment.likes }}
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="sides">
          <menuTitle :titles="righttitles"></menuTitle>
          <leftcheck></leftcheck>
        </div>
      </div>
    </div>
    <footerbox></footerbox>
  </div>
</template>

<script>
import { comments } from "@/common/until/reviews";

import footerbox from "components/content/footer";
import headerbox from "components/content/header";
import hotelhead from "components/content/hotelhead";
import leftcheck from "components/content/Leftcheck";
import menuTitle from "components/content/menuTitle";
export default {
  name: "News",
  data() {
    return {
      righttitles: "在线酒店查询",
      lefttitles: "顾客评论",
    };
  },
  components: {
    footerbox,
    headerbox,
    hotelhead,
    leftcheck,
    menuTitle,
  },
  mounted() {
     
  },
  methods: {
   

  },
  computed: {
    commentslist() {
      const cachedId = localStorage.getItem("cachedId");
      // console.log(cachedId);

      // Calculate the starting index based on cachedId
      const lastDigit = cachedId
        ? parseInt(cachedId.toString().slice(-1))
        : null;
      const startIndex = lastDigit ? (lastDigit - 1) * 10 : 0;
      // console.log(startIndex);

      // Get the desired data range
      let result;
      if (comments.length >= startIndex) {
        result = comments.slice(startIndex, startIndex + 10);
      } else {
        result = comments.slice(0, 10);
      }
      return result;
    },
  },
};
</script>

<style lang="less">
.reviews {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  .reviewsleft {
    width: 750px;
    ul {
      li {
        display: flex;
        justify-content: flex-startt;
        border-bottom: 1px solid #e5e5e5;
        padding: 15px 0 17px;
        .commentsphoto {
          padding: 0 18px;
          img {
            border-radius: 50%;
            width: 46px;
            height: 46px;
          }
        }
        .commentstext {
          h3 {
            line-height: 36px;
            font-size: 14px;
            font-weight: normal;
            color: #888888;
          }
          h4 {
            font-weight: 400;
            color: #333333;
            font-size: 12px;
            line-height: 24px;
            padding-bottom: 10px;
          }
          p {
            display: flex;
            align-items: center;
            color: #888;
            img {
              margin-right: 6px;
            }
          }
        }
      }
    }
  }
}
</style>


 
 
 

 
 